import React, { useEffect, useState, useRef } from 'react';
const products = [{
  name: 'Olive Leaf 8:11',
  subtitle: 'Immune Defense',
  image: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/72532349-ff6e-47c4-9330-04556b782119.png?v=1763794573',
  link: 'https://oliveleaf.faithandfig.com'
}, {
  name: 'Frakincense 2:11',
  subtitle: 'Joint Comfort',
  image: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/843ed722-fcab-49c4-9afc-c384ca51f27b.png?v=1763794574',
  link: 'https://frankincense.faithandfig.com'
}, {
  name: 'Saffron 4:14',
  subtitle: 'Calm Focus',
  image: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/d8c379ca-5600-45f5-9690-97da2d6011ee.png?v=1763794573',
  link: 'https://trysaffron.faithandfig.com'
}, {
  name: 'Pomegranate 8:8',
  subtitle: 'Heart Health',
  image: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/e4ab495b-c6f7-4193-b677-9b7d9923de4f.png?v=1763794573',
  link: 'https://pomegranates.faithandfig.com'
}];
export const ProductShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  return <section ref={sectionRef} id="products-section" className="relative bg-[#2d4a3e] py-20 overflow-hidden" data-id="element-213">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-214">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-215"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-216">
        <div className={`mb-16 transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-217">
          <div className="inline-flex items-center gap-2 bg-[#9dc183] px-4 py-2 rounded-full text-xs font-medium mb-4" data-id="element-218">
            <span className="text-[#2d4a3e]" data-id="element-219">● Our Products + Black Friday ●</span>
          </div>

          <h2 className="text-white text-4xl md:text-6xl font-light mb-4 leading-tight" data-id="element-220">
            Wellness Rooted in Scripture.
          </h2>
          <p className="text-white/70 text-sm max-w-3xl leading-relaxed" data-id="element-221">
            From biblical ingredients to rooted mind–body–spirit formulas, each
            F&F supplement is crafted with clinically informed ingredients to
            help keep you aligned with your purpose, the present moment, and
            your faith.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-222">
          {products.map((product, index) => <div key={index} className={`group transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} style={{
          transitionDelay: `${index * 100 + 100}ms`
        }} data-id="element-223">
              <div className="relative bg-white/10 backdrop-blur-md rounded-2xl p-2 mb-4 aspect-square flex items-center justify-center overflow-hidden border border-white/10 hover:border-white/30 transition-all duration-300" data-id="element-224">
                <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-225"></div>
                <img src={product.image} alt={product.name} className="w-full h-full object-contain relative z-10 transform group-hover:scale-125 transition-transform duration-300" data-id="element-226" />
              </div>

              <h3 className="text-white text-lg font-medium mb-1" data-id="element-227">
                {product.name}
              </h3>
              <p className="text-white/60 text-sm mb-4" data-id="element-228">{product.subtitle}</p>

              <a href={product.link} className="bg-white/90 backdrop-blur-sm text-[#2d4a3e] px-6 py-2 rounded-full hover:bg-white transition-all duration-300 text-sm font-medium border border-white/20 block text-center" data-id="element-229">
                Start Now
              </a>
            </div>)}
        </div>
      </div>
    </section>;
};